module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-Surrey-bfa94946208aab42c2de64423563aeb3.svg";